<div class="offering-vendor">
  <h1 class="ui-heading-1-bold offering-vendor-title">
    {{ section() }}
  </h1>

  <rds-basic-card layout="horizontal">
    <rds-card-header>
      <rds-card-title
        ><span class="ui-heading-4">
          {{ vendorName() }}
        </span></rds-card-title
      >
    </rds-card-header>
    <rds-card-content>
      <div class="offering-vendor-content">
        <p class="article-body-m">
          {{ vendorSupport() }}
        </p>
        @if (vendorUrl()) {
          <a
            class="link"
            rds-link
            standalone
            [href]="vendorUrl()"
            target="_blank"
          >
            {{ BUTTONS.VENDOR_ACTION }}
            <rds-icon namespace="filled" icon="arrow_right" />
          </a>
        }
      </div>
    </rds-card-content>
  </rds-basic-card>
</div>
